import { render, staticRenderFns } from "./LoggedInLayout.vue?vue&type=template&id=06f95703&scoped=true&"
import script from "./LoggedInLayout.vue?vue&type=script&lang=js&"
export * from "./LoggedInLayout.vue?vue&type=script&lang=js&"
import style0 from "./LoggedInLayout.vue?vue&type=style&index=0&id=06f95703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f95703",
  null
  
)

export default component.exports